<template>
    <div class="access">
        <div class="Deduction-content">
            <div class="border-bottom" style="overflow: hidden;">
                <el-form ref="ruleForm" class="demo-ruleForm" label-width="100px">
                    <el-row>
                        <el-col :span="5">
                            <el-form-item label="开始日期" prop="starttime">
                                <el-date-picker
                                    v-model="ruleForm.starttime"
                                    type="date"
                                    @change="startDate"
                                    placeholder="选择开始日期"
                                    format="yyyy-MM-dd HH:mm:ss"
                                ></el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="5">
                            <el-form-item label="结束日期" prop="endtime">
                                <el-date-picker
                                    v-model="ruleForm.endtime"
                                    type="date"
                                    @change="endDate"
                                    placeholder="选择结束日期"
                                    format="yyyy-MM-dd HH:mm:ss"
                                ></el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label prop="staffvalue">
                                <el-input v-model="ruleForm.input" placeholder="商品全称、商品简称、商品描述" style="width: 60%;"></el-input>
                                <el-button type="primary" style="margin-left: 5px;" @click="search2">搜索</el-button>
                                <el-button type="primary" @click="searchReset">重置</el-button>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
            <el-row class="margin-top1">
                <el-col>
                    <el-button type="primary" @click="shelves">上架</el-button>
                </el-col>
            </el-row>
            <div class="margin-top1">
                <el-table :data="tableData" border style="width: 100%" v-loading="loading">
                    <el-table-column align="center" prop="inventoryNumber" label="库存编号"></el-table-column>
                    <el-table-column align="center" label="商品图片">
                        <template slot-scope="scope">
                            <el-popover trigger="hover" placement="right" style="float: left;">
                                <img :src="scope.row.images" class="prduct_img" alt />
                                <div class="scope_img" slot="reference">
                                    <img :src="scope.row.images" alt />
                                </div>
                            </el-popover>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" prop="productFullName" label="商品全称"></el-table-column>
                    <el-table-column align="center" prop="productSimpleName" label="商品简称"></el-table-column>
                    <el-table-column width="200" align="center" prop="productDescription" label="商品描述"></el-table-column>
                    <el-table-column align="center" prop="originalPrice" label="原价"></el-table-column>
                    <el-table-column align="center" prop="currentPrice" label="现价"></el-table-column>
                    <!-- <el-table-column align="center" prop="purchasePrice" label="采购单价"></el-table-column> -->
                    <el-table-column align="center" prop="actualCount" label="库存数量"></el-table-column>
                    <el-table-column align="center" width="200" prop="onLineTime" label="上架时间"></el-table-column>
                    <el-table-column align="center" label="操作" width="170">
                        <template slot-scope="scope">
                            <el-button @click="Edit(scope.row)" type="primary">编辑</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <el-dialog title="上架商品" :visible.sync="dialogVisible" width="50%">
                <div>
                    <el-table :data="goodsList" border style="width: 100%" v-loading="loading1">
                        <el-table-column align="center" prop="inventoryNumber" label="库存编号"></el-table-column>
                        <el-table-column align="center" width="70" label="商品图片">
                            <template slot-scope="scope">
                            <el-popover trigger="hover" placement="right" style="float: left;">
                                <img :src="scope.row.images" class="prduct_img" alt />
                                <div slot="reference">
                                    <img :src="scope.row.images" alt style="width:50px;height:50px;"/>
                                </div>
                            </el-popover>
                        </template>
                        </el-table-column>
                        <el-table-column align="center" prop="productFullName" label="商品全称"></el-table-column>
                        <el-table-column align="center" prop="productSimpleName" label="商品简称"></el-table-column>
                        <el-table-column align="center" prop="productDescription" label="商品描述"></el-table-column>
                        <el-table-column align="center" prop="purchasePrice" label="采购单价"></el-table-column>
                        <el-table-column align="center" prop="actualCount" label="库存数量"></el-table-column>
                        <el-table-column align="center" label="操作">
                            <template slot-scope="scope">
                                <el-button type="primary" @click="shelvesGoods(scope.row)">上架</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <el-pagination
                    style="margin-top:15px;text-align:center;"
                    @size-change="handleSizeChange1"
                    @current-change="handleCurrentChange1"
                    :current-page="currentPage1"
                    :page-sizes="[50, 100, 200, 400]"
                    :page-size="pagesize1"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total1"
                ></el-pagination>
            </el-dialog>

            <el-dialog title="上架商品" :visible.sync="GoodsDetails" width="31%">
                <div class="box">
                    <div v-for="(item,i) in this.goodsMain.imagesList" :key="i" style="margin-left:10px;">
                        <img :src="item" style="width:100px;height:100px;">
                    </div>
                </div>
                <div style="margin-top:15px;">
                    商品全称：{{this.goodsMain.productFullName}}
                </div>
                <div style="margin-top:15px;">
                    商品简称：{{this.goodsMain.productSimpleName}}
                </div>
                <div style="margin-top:15px;">
                    商品描述：{{this.goodsMain.productDescription}}
                </div>
                <div style="margin-top:15px;">
                    采购单价：{{this.goodsMain.purchasePrice}}
                </div>
                <div style="margin-top:15px;">
                    库存数量：{{this.goodsMain.actualCount}}
                </div>
                <div style="margin-top:15px;">
                    设置上架信息：
                </div>
                <div style="margin-top:15px;">
                    <label>原价：</label><el-input v-model="originalPrice" style="width:200px;" onkeyup="value=value.replace(/[^\d.]/g,'')"></el-input>
                    <label style="margin-left:20px;">现价：</label><el-input v-model="currentPrice" style="width:200px;" onkeyup="value=value.replace(/[^\d.]/g,'')"></el-input>
                </div>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="cancel">取 消</el-button>
                    <el-button type="primary" @click="Add">确 定</el-button>
                </span>
            </el-dialog>

            <el-dialog title="编辑上架商品" :visible.sync="EditGoodsDetails" width="31%">
                <div class="box">
                    <div v-for="(item,i) in this.EditGoods.imagesList" :key="i" style="margin-left:10px;">
                        <img :src="item" style="width:100px;height:100px;">
                    </div>
                </div>
                <div style="margin-top:15px;">
                    商品全称：{{this.EditGoods.productFullName}}
                </div>
                <div style="margin-top:15px;">
                    商品简称：{{this.EditGoods.productSimpleName}}
                </div>
                <div style="margin-top:15px;">
                    商品描述：{{this.EditGoods.productDescription}}
                </div>
                <div style="margin-top:20px;">
                     <el-table :data="this.EditGoods.GoodListData" border style="width: 100%" :loading="loading3"
                     >
                     <el-table-column align="center" prop="inventoryBatchNo" label="批次号"></el-table-column>
                     <el-table-column align="center" prop="purchaseQuantity" label="采购数量"></el-table-column>
                     <el-table-column align="center" prop="purchasePrice" label="采购单价"></el-table-column>
                     </el-table>
                    <!-- 采购单价：{{this.EditGoods.purchasePrice}} -->
                </div>
                <div style="margin-top:20px;">
                    库存数量：{{this.EditGoods.actualCount}}
                </div>
                <div style="margin-top:15px;">
                    设置上架信息：
                </div>
                <div style="margin-top:15px;">
                    <label>原价：</label><el-input v-model="originalPrice1" style="width:200px;" onkeyup="value=value.replace(/[^\d.]/g,'')"></el-input>
                    <label style="margin-left:20px;">现价：</label><el-input v-model="currentPrice1" style="width:200px;" onkeyup="value=value.replace(/[^\d.]/g,'')"></el-input>
                </div>
                <span slot="footer" class="dialog-footer">
                    <el-button type="danger" @click="TheShelves">下 架</el-button>
                    <el-button @click="EditGoodsDetails = false">取 消</el-button>
                    <el-button type="primary" @click="EditSub">确 定</el-button>
                </span>
            </el-dialog>

            <div class="page">
                <el-pagination
                    style="margin-right:200px;"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[50, 100, 200, 400]"
                    :page-size="pagesize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total"
                ></el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
import { ajaxPost, Baseurl } from "../../../api/api/api";
export default {
    name: "HxShoppingMall",
    data() {
        return {
            tableData: [],
            goodsList:[],
            dialogVisible:false,
            GoodsDetails:false,
            EditGoodsDetails:false,
            loading:true,
            loading1:true,
            loading3:true,
            goodsMain:"",
            EditGoods:"",
            ruleForm: {
                starttime: "", //开始时间
                endtime: "", //结束时间
                input: "",
            },
            currentPage: 1,
            pagesize: 50,
            size: 50,
            total: 0,

            currentPage1: 1,
            pagesize1: 50,
            size1: 50,
            total1: 0,

            originalPrice:"",
            currentPrice:"",

            originalPrice1:"",
            currentPrice1:"",
        };
    },
    created() {
        this.search()
    },
    methods: {
        search2(){
            this.currentPage = 1
            this.search()
        },
        search(){
                var obj = {
                    page:this.currentPage,
                    size:this.size,
                    startTimeString:this.ruleForm.starttime,
                    endTimeString:this.ruleForm.endtime,
                    searchString:this.ruleForm.input
                };
                ajaxPost(Baseurl + "inventoryController/selectOnLineInventorysList",obj).then(res => {
                    if(res.data.code == 200){
                        this.tableData = res.data.data.list
                        this.total = res.data.data.total
                    }
                    this.loading = false
                });
        },
        searchReset() {
            this.ruleForm.starttime = ""
            this.ruleForm.endtime = ""
            this.ruleForm.input = ""
            this.currentPage = 1
            this.search()
        },
        shelves() {
            this.dialogVisible = true
            this.Goods()
        },
        Goods(){
                var obj = {
                    page:this.currentPage1,
                    size:this.size1,
                };
                ajaxPost(Baseurl + "inventoryController/selectUnOnLineInventorysList",obj).then(res => {
                    if(res.data.code == 200){
                        this.goodsList = res.data.data.list
                        this.total1 = res.data.data.total
                    }
                    this.loading1 = false
                });
        },
        shelvesGoods(val){
            console.log(val)
            this.GoodsDetails = true
            this.goodsMain = val
        },
        Add(){
            if(this.originalPrice == ""){
                this.$message.error('请填写原价')
            }else if(this.currentPrice == ""){
                this.$message.error('请填写现价')
            }else{
                var obj = {
                    id:this.goodsMain.id,
                    originalPrice:this.originalPrice,
                    currentPrice:this.currentPrice,
                    onLineStatus:1
                };
                ajaxPost(Baseurl + "inventoryController/updateOnLineStatusById",obj).then(res => {
                    if(res.data.code == 200){
                        this.$message({
                            message:'上架成功',
                            type:'success'
                        })
                        this.Goods()
                        this.search()
                    }
                    this.GoodsDetails = false
                    this.currentPrice = ""
                    this.originalPrice = ""
                });
            }
                
        },
        cancel(){
            this.GoodsDetails = false
            this.currentPrice = ""
            this.originalPrice = ""
        },
        Edit(val){
            // console.log(JSON.parse(JSON.stringify(val)))
  
            this.EditGoodsDetails = true
            this.EditGoods = val;
            this.originalPrice1 = val.originalPrice;
            this.currentPrice1 = val.currentPrice;
                      let API = Baseurl + "inventoryController/getPurchasesByInventoryNo";
            ajaxPost(API,{inventoryNumber:val.inventoryNumber}).then(res=>{
                if(res.data.code ==200){
                    console.log(res.data.data)
                    this.EditGoods.GoodListData = res.data.data;
                    this.loading3 = false;
                }
                // console.log(res)
            })
        },
        EditSub(){
            var obj = {
                    id:this.EditGoods.id,
                    originalPrice:this.originalPrice1,
                    currentPrice:this.currentPrice1,
            };
                ajaxPost(Baseurl + "inventoryController/updateOnLineStatusById",obj).then(res => {
                    if(res.data.code == 200){
                        this.$message({
                            message:'编辑上架商品成功',
                            type:'success'
                        })
                        this.search()
                    }
                    this.EditGoodsDetails = false
                });
        },
        TheShelves(){
            var obj = {
                    id:this.EditGoods.id,
                    onLineStatus:0
            };
                ajaxPost(Baseurl + "inventoryController/updateOnLineStatusById",obj).then(res => {
                    if(res.data.code == 200){
                        this.$message({
                            message:'下架商品成功',
                            type:'success'
                        })
                        this.search()
                    }
                    this.EditGoodsDetails = false
                });
        },
        handleSizeChange(val) {
            // console.log(`每页 ${val} 条`);
            this.size = val;
            this.search()
        },
        handleCurrentChange(val) {
            // console.log(`当前页: ${val}`);
            this.currentPage = val;
            this.search()
        },

        handleSizeChange1(val) {
            // console.log(`每页 ${val} 条`);
            this.size1 = val;
            this.Goods()
        },
        handleCurrentChange1(val) {
            // console.log(`当前页: ${val}`);
            this.currentPage1 = val;
            this.Goods()
        },
        //选择开始日期
        startDate(val) {
            var d = new Date(val);
            var datetime =
                d.getFullYear() +
                "-" +
                (d.getMonth() + 1) +
                "-" +
                d.getDate() +
                " 00:00:00";
            this.ruleForm.starttime = datetime;
        },
        //选择结束日期
        endDate(val) {
            var d = new Date(val);
            var datetime =
                d.getFullYear() +
                "-" +
                (d.getMonth() + 1) +
                "-" +
                d.getDate() +
                " 23:59:59";
            this.ruleForm.endtime = datetime;
        },
    },
};
</script>

<style lang="scss" scoped>
// /deep/ {
//   .layout .layout-section ::-webkit-scrollbar {
//     width: 10px;
//     height: 10px;
//     background-color: #b71e1e;
//   }
//   .el-form-item__label {
//     width: 120px!important;
//   }
// }
.HxShoppingMall {
    width: 98%;
    overflow: hidden;
    .Deduction-content {
        margin-top: 20px;
        .Reportform_tiem {
            overflow: hidden;
            border-top: 1px solid #eee;
            padding: 15px 0;
            .search-result-text {
                font-size: 14px;
                color: #606266;
                padding: 0;
            }
            .el-radio-group {
                display: inline-block;
                line-height: 1;
                vertical-align: middle;
                font-size: 0;
                margin-left: 20px;
            }
        }
    }
}
.paging {
    width: 40%;
    margin: 20px auto;
}
.prduct_img {
    width: 500px;
    height: 500px;
}
.scope_img {
    width: 123px;
    height: 123px;
    img {
        width: 100%;
        height: 100%;
    }
}
.box{
    display: flex;
    justify-content: left;
    flex-wrap: wrap;
}
.page {
            position: fixed;
            width: 100%;
            bottom: 0;
            background-color: white;
            display: flex;
            justify-content: center;
            align-items: center;
            height: 50px;
        }
</style>
